var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265.284,
    height: 85.011,
    viewBox: "0 0 265.284 85.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.537,
    y1: -0.214,
    x2: 0.54,
    y2: 1.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd5e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2b926b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b926b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M10.727,50.709V10.577H33.661V50.709A10.894,10.894,0,0,1,22.768,61.6H21.62A10.894,10.894,0,0,1,10.727,50.709M36.738,4H5.343A3.424,3.424,0,0,0,1.8,7.291a3.424,3.424,0,0,0,3.546,3.286H5.96V50.709A15.672,15.672,0,0,0,21.62,66.364h1.148A15.669,15.669,0,0,0,38.429,50.709V10.577h.622a3.419,3.419,0,0,0,3.54-3.286A3.419,3.419,0,0,0,39.051,4Z",
    transform: "translate(-1.797 -4.005)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 4.196,
    height: 1.895,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 4.196,
    height: 1.9,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M3.723,11.183V26.895a8.954,8.954,0,0,0,8.947,8.936h1.12a8.949,8.949,0,0,0,8.942-8.936V10.426a6.037,6.037,0,0,1-2.862.509c-3.145-.243-7.251-1.782-10.825-1.782a6.862,6.862,0,0,0-5.322,2.03",
    transform: "translate(-3.723 -9.153)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M8.192,8.231a40.6,40.6,0,0,1,2.076,5.254h3.591a25.637,25.637,0,0,1,1.12-2.918c1.42-3.1,3.1-5.186,4.988-6.323.147-.09.305-.17.452-.255a13.987,13.987,0,0,0-3.608.843A12.266,12.266,0,0,0,12.756,7.5c-.249.243-.5.509-.741.775L12,8.231c-.345-.334-.707-.662-1.08-1.012A74.9,74.9,0,0,0,4.125,1.688l-.011-.006A47.629,47.629,0,0,1,8.192,8.231",
    transform: "translate(-4.114 -1.682)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M5.059,3.565a2.477,2.477,0,0,0,2.059,2.8,2.418,2.418,0,0,0,2.72-2.127A2.48,2.48,0,0,0,7.779,1.428,3.2,3.2,0,0,0,7.451,1.4a2.448,2.448,0,0,0-2.392,2.16",
    transform: "translate(-5.036 -1.405)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M23.279,3.846a44.6,44.6,0,0,0-8.025,6.442c-.481.475-.956.973-1.425,1.47l.006-.057c-.311-.435-.628-.865-.956-1.306A42.181,42.181,0,0,0,6.833,4.049H6.827A43.713,43.713,0,0,1,9.038,12.7a49.583,49.583,0,0,1,.328,8.614H12.63c1.34-2.353,2.737-4.592,4.2-6.679A60.66,60.66,0,0,1,29.846.854c.4-.294.8-.571,1.2-.854a47.247,47.247,0,0,0-7.765,3.846",
    transform: "translate(-6.827)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M7.6,3.565a3.413,3.413,0,0,0,3.263,3.546,3.417,3.417,0,0,0,3.263-3.546A3.415,3.415,0,0,0,10.862.025,3.412,3.412,0,0,0,7.6,3.565",
    transform: "translate(-7.599 -0.025)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1.159,1.208a58.78,58.78,0,0,1,12.72,13.353c1.114,1.567,2.183,3.241,3.224,4.977h4.016a45.255,45.255,0,0,1,.379-6.855A42.162,42.162,0,0,1,23.652,4.3h-.006a41.313,41.313,0,0,0-5.9,6.148c-.322.424-.628.843-.933,1.261l.006.062c-.458-.486-.928-.961-1.391-1.431a43.637,43.637,0,0,0-7.85-6.233A45.994,45.994,0,0,0,0,.382c.385.266.78.537,1.159.826",
    transform: "translate(0 -0.382)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M2.3,3.834a3.317,3.317,0,0,0,3.19,3.433,3.317,3.317,0,0,0,3.19-3.433A3.312,3.312,0,0,0,5.491.407,3.312,3.312,0,0,0,2.3,3.834",
    transform: "translate(-2.301 -0.407)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 265.284,
    height: 85.01,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(10.163 22.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 72.445,
    height: 73.369,
    transform: "translate(-31.122 29.292) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(34.533 39.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 4.354,
    height: 4.256,
    transform: "translate(-0.946 0.89) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(34.533 34.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 4.358,
    height: 4.26,
    transform: "translate(-0.948 0.893) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(34.533 44.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 4.354,
    height: 4.256,
    transform: "translate(-0.946 0.89) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(21.056 51.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 32.126,
    height: 32.455,
    transform: "translate(-13.314 12.532) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(23.267 9.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 19.963,
    height: 19.77,
    transform: "translate(-5.891 5.545) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(28.482 7.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 7.279,
    height: 7.279,
    transform: "matrix(0.728, -0.685, 0.685, 0.728, -2.73, 2.421)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(38.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 32.245,
    height: 32.12,
    transform: "translate(-10.639 10.013) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(42.977 0.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 9.61,
    height: 9.634,
    transform: "translate(-3.537 3.329) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(0 2.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 30.352,
    height: 30.159,
    transform: "translate(-9.56 8.998) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(13.014 2.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 9.347,
    height: 9.368,
    transform: "translate(-3.424 3.223) rotate(-43.264)",
    fill: "url(#linear-gradient)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M31.585,30.4v5.882H11.258V5.867h6.849V30.4Z",
    transform: "translate(52.415 27.312)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M25.007,7.054a15.257,15.257,0,0,1,4.83.656A7.533,7.533,0,0,1,32.93,9.6a7.016,7.016,0,0,1,1.646,2.986,14.918,14.918,0,0,1,.486,3.9V30.1q-1.408.305-3.914.724a37.551,37.551,0,0,1-6.052.419,19.426,19.426,0,0,1-4.061-.4,8.888,8.888,0,0,1-3.139-1.3A5.967,5.967,0,0,1,15.878,27.2a8.108,8.108,0,0,1-.7-3.557,6.706,6.706,0,0,1,.814-3.422,6.187,6.187,0,0,1,2.166-2.24,9.921,9.921,0,0,1,3.122-1.2,17.408,17.408,0,0,1,3.642-.373,20.535,20.535,0,0,1,2.257.107,10.589,10.589,0,0,1,1.6.283v-.611a3.6,3.6,0,0,0-1.007-2.675,4.889,4.889,0,0,0-3.512-1.012,22.007,22.007,0,0,0-3.292.243,13.941,13.941,0,0,0-2.811.679l-.831-5.265c.379-.113.854-.243,1.431-.373s1.188-.249,1.861-.351S22,7.235,22.75,7.161s1.493-.107,2.257-.107m.526,19.133c.645,0,1.261-.011,1.844-.045a12.865,12.865,0,0,0,1.4-.13v-4.96c-.26-.057-.656-.113-1.182-.175a13.681,13.681,0,0,0-1.448-.085,12.8,12.8,0,0,0-1.731.107,4.613,4.613,0,0,0-1.431.419,2.425,2.425,0,0,0-.961.831,2.3,2.3,0,0,0-.356,1.318A2.248,2.248,0,0,0,22.7,25.6a5.736,5.736,0,0,0,2.828.588",
    transform: "translate(70.659 32.84)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M41.009,27.737a14.565,14.565,0,0,1-.814,5.005,10.663,10.663,0,0,1-2.347,3.818,10.388,10.388,0,0,1-3.778,2.432,14.135,14.135,0,0,1-5.084.86c-.792,0-1.618-.04-2.483-.113s-1.708-.164-2.545-.283-1.634-.255-2.392-.419-1.437-.328-2.019-.5V6.274l6.538-1.052v11.5a11.8,11.8,0,0,1,2.279-.741,11.426,11.426,0,0,1,2.551-.266,10.408,10.408,0,0,1,4.344.854A8.559,8.559,0,0,1,38.419,19,11.07,11.07,0,0,1,40.348,22.8a17.212,17.212,0,0,1,.662,4.937m-6.674-.175q0-6.32-4.649-6.317a7.751,7.751,0,0,0-2,.26,5.76,5.76,0,0,0-1.6.656V34.055c.322.062.73.113,1.233.158s1.035.062,1.623.062a4.7,4.7,0,0,0,4.038-1.844,8.015,8.015,0,0,0,1.357-4.87",
    transform: "translate(90.999 24.311)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M31.784,26.057a6.573,6.573,0,0,0,2.545-.351,1.363,1.363,0,0,0,.747-1.363,1.658,1.658,0,0,0-.967-1.38,18.172,18.172,0,0,0-2.935-1.34,28.834,28.834,0,0,1-2.794-1.188,8.184,8.184,0,0,1-2.127-1.465A6.032,6.032,0,0,1,24.9,16.929a7.558,7.558,0,0,1-.486-2.856,6.171,6.171,0,0,1,2.415-5.13,10.475,10.475,0,0,1,6.628-1.889,21.274,21.274,0,0,1,4.038.373,18.776,18.776,0,0,1,3.071.814l-1.137,5.09a25.1,25.1,0,0,0-2.483-.707,13.569,13.569,0,0,0-3.009-.305c-2.042,0-3.071.571-3.071,1.714a1.824,1.824,0,0,0,.13.7,1.57,1.57,0,0,0,.526.594,7.749,7.749,0,0,0,1.08.616q.679.331,1.731.73a26.143,26.143,0,0,1,3.552,1.572A8.442,8.442,0,0,1,40.1,19.915a5.13,5.13,0,0,1,1.137,2,8.772,8.772,0,0,1,.328,2.534A5.852,5.852,0,0,1,39,29.614q-2.562,1.748-7.262,1.748a20.948,20.948,0,0,1-5.113-.52,20.057,20.057,0,0,1-2.828-.882l1.1-5.311a21.29,21.29,0,0,0,3.422,1.035,16.627,16.627,0,0,0,3.467.373",
    transform: "translate(110.795 32.84)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M46.749,5.867V24.123H50v5.356H46.749v6.8H40.341v-6.8H27.22V24.695c.639-1.289,1.448-2.743,2.409-4.366s2.042-3.292,3.229-5.005,2.432-3.382,3.75-5.022a55.9,55.9,0,0,1,3.948-4.434Zm-6.408,7.986q-1.714,2.24-3.648,4.87a34.19,34.19,0,0,0-3.246,5.4h6.894Z",
    transform: "translate(126.727 27.314)",
    fill: "#4bb599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M31.9,36.278V5.867H52.265v5.746H38.743v6.363H50.766v5.752H38.743v12.55Z",
    transform: "translate(148.512 27.315)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M49.844,13.355c-.588-.147-1.278-.3-2.064-.464a12.917,12.917,0,0,0-2.545-.243,11.549,11.549,0,0,0-1.465.113,8.05,8.05,0,0,0-1.3.243v17.64H35.925V8.791a40,40,0,0,1,4.151-1.165,23.872,23.872,0,0,1,5.339-.549c.345,0,.769.023,1.261.068s1,.1,1.493.175,1,.158,1.493.26a7.564,7.564,0,0,1,1.273.373Z",
    transform: "translate(167.254 32.948)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M38.735,19.383a14.158,14.158,0,0,1,.939-5.373,11.58,11.58,0,0,1,2.483-3.84,10.278,10.278,0,0,1,3.535-2.324,11.06,11.06,0,0,1,4.1-.792,10.2,10.2,0,0,1,7.765,3q2.859,3.012,2.856,8.845c0,.379-.017.8-.045,1.25s-.057.854-.085,1.21H45.448a4.341,4.341,0,0,0,1.889,3.2,7.557,7.557,0,0,0,4.474,1.182,18.767,18.767,0,0,0,3.535-.328,13.187,13.187,0,0,0,2.833-.809l.871,5.311a9.093,9.093,0,0,1-1.4.526A18.453,18.453,0,0,1,55.7,30.9c-.718.13-1.482.243-2.308.334a23.813,23.813,0,0,1-2.46.13,14.625,14.625,0,0,1-5.418-.922A10.548,10.548,0,0,1,41.7,27.923a9.966,9.966,0,0,1-2.24-3.8,14.892,14.892,0,0,1-.724-4.739m15.361-2.5a6.835,6.835,0,0,0-.288-1.623,3.952,3.952,0,0,0-2.019-2.415,4.172,4.172,0,0,0-1.906-.4,4.379,4.379,0,0,0-1.889.373,3.946,3.946,0,0,0-1.318.99,4.308,4.308,0,0,0-.809,1.425,9.01,9.01,0,0,0-.419,1.646Z",
    transform: "translate(180.337 32.84)",
    fill: "#368582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M43.073,19.383a14.158,14.158,0,0,1,.939-5.373,11.58,11.58,0,0,1,2.483-3.84,10.278,10.278,0,0,1,3.535-2.324,11.06,11.06,0,0,1,4.1-.792,10.2,10.2,0,0,1,7.765,3q2.859,3.012,2.856,8.845c0,.379-.017.8-.045,1.25s-.057.854-.085,1.21H49.786a4.341,4.341,0,0,0,1.889,3.2,7.556,7.556,0,0,0,4.474,1.182,18.767,18.767,0,0,0,3.535-.328,13.186,13.186,0,0,0,2.833-.809l.871,5.311a9.094,9.094,0,0,1-1.4.526,18.451,18.451,0,0,1-1.951.458c-.718.13-1.482.243-2.307.334a23.813,23.813,0,0,1-2.46.13,14.625,14.625,0,0,1-5.418-.922,10.548,10.548,0,0,1-3.812-2.522,9.965,9.965,0,0,1-2.24-3.8,14.892,14.892,0,0,1-.724-4.739m15.361-2.5a6.836,6.836,0,0,0-.288-1.623,3.952,3.952,0,0,0-2.019-2.415,4.172,4.172,0,0,0-1.906-.4,4.379,4.379,0,0,0-1.889.373,3.946,3.946,0,0,0-1.318.99,4.309,4.309,0,0,0-.809,1.425,9.014,9.014,0,0,0-.419,1.646Z",
    transform: "translate(200.533 32.84)",
    fill: "#368582"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3536113823c6f25e49aec1e5cca4d2bb.svg";
export { ForwardRef as ReactComponent };